(function() {
'use strict';

    angular
        .module('roadMeasurements')
        .service('roadMeasurementsService', roadMeasurementsService);

    roadMeasurementsService.$inject = ['$http', '$rootScope', 'serviceBase'];
    function roadMeasurementsService($http, $rootScope, serviceBase) {
        var service = this;
        service.RESOURCE_PATH = '/resource/keliu-matavimai';
        service.coords = {};

        service.getMeasurement = getMeasurement;
        service.getNextMeasurement = getNextMeasurement;
        service.getPreviousMeasurement = getPreviousMeasurement;
        service.getAllMeasurements = getAllMeasurements;

        return service;

        ////////////////

        function getMeasurement(query) {
            return $http.get(serviceBase + service.RESOURCE_PATH, {params: query});
        }
        function getNextMeasurement(query) {
            return $http.get(serviceBase + service.RESOURCE_PATH + '/next', {params: query});
        }
        function getPreviousMeasurement(query) {
            return $http.get(serviceBase + service.RESOURCE_PATH + '/previous', {params: query});
        }
        function getAllMeasurements(query) {
            return $http.get(serviceBase + service.RESOURCE_PATH + '/all', {params: query});
        }
    }
})();
